import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { FunctionalHelpJsonModel } from '../functionalHelp.json.model';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';

@Injectable({
  providedIn: 'root'
})
export class FunctionHelpService extends BaseCollectionService<FunctionalHelpJsonModel, AppCollection> {
  protected ctor = FunctionalHelpJsonModel;
}
